import { Pipe, PipeTransform } from '@angular/core';
import { translate } from '@jsverse/transloco';

import { ExperienceCardIconButton, Icons } from '@inmoment/the-kitchen';

import {
  DefaultQuickActionIconsEnum,
  QuickActionsItem,
} from 'app/modules/collection/services/documents-quick-action.service';
import { Document } from 'app/providers/storage-api/document.service';

@Pipe({
  name: 'cardViewQuickActions',
  standalone: false,
})
export class CardViewQuickActionsPipe implements PipeTransform {
  transform(actions: QuickActionsItem[], item?: Document): ExperienceCardIconButton[] {
    if (!actions) {
      return;
    }
    return actions.map((action) => {
      const doesContainTag = this.doesContainTag(action, item);

      return {
        type: 'tooltip',
        icon: this.getIcon(doesContainTag, action.icon),
        title: this.getTitle(doesContainTag, action.title),
        alwaysDisplay: true,
        onClick: () => this.getOnClickFunction(action, item),
      };
    });
  }

  private getOnClickFunction(action: QuickActionsItem, item: Document): void {
    switch (action.icon) {
      case DefaultQuickActionIconsEnum.TRASH:
        return action.deleteFunction(item);
      case DefaultQuickActionIconsEnum.TAG:
        return action.tagFunction(item);
      case DefaultQuickActionIconsEnum.TAG_FILLED:
        return action.untagFunction(item);
      default:
        if (this.doesContainTag(action, item)) {
          return action.cardViewTagSelection({
            action: 'REMOVE',
            tags: [action.tag],
            document: item,
          });
        }

        return action.cardViewTagSelection({
          action: 'ADD',
          tags: [action.tag],
          document: item,
        });
    }
  }

  private getIcon(doesContainTag: boolean, icon: Icons): Icons {
    if (
      icon === DefaultQuickActionIconsEnum.TAG ||
      icon === DefaultQuickActionIconsEnum.TAG_FILLED ||
      icon === DefaultQuickActionIconsEnum.TRASH
    ) {
      return icon;
    }

    const original = icon.split('_filled')[0] as Icons;
    if (doesContainTag) {
      return `${original}_filled` as Icons;
    }

    return original;
  }

  private getTitle(doesContainTag, title: string): string {
    return doesContainTag
      ? translate('documents.list-settings.quick-actions.clear-title', { title })
      : title;
  }

  private doesContainTag(action: QuickActionsItem, item?: any): boolean {
    return item?.tags?.some(
      (tag) => tag?.trim()?.toLowerCase() === action.tag?.trim()?.toLowerCase()
    );
  }
}
